// extracted by mini-css-extract-plugin
module.exports = {"container":"projects-module--container--3pyny","title":"projects-module--title--20xwJ","intro":"projects-module--intro--3qHNU"};